import React from 'react';
import { NavLink } from 'react-router-dom';
import { toggleTheme } from '../theme';
import { logout } from '../api';

export default function Navbar({ user, onLogout }) {
  const handleLogout = async () => {
    await logout();
    onLogout?.();
  };

  return (
    <nav className="navbar">
      <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : '')}>
        Home
      </NavLink>
      <NavLink to="/how-it-works" className={({ isActive }) => (isActive ? 'active' : '')}>
        How it Works
      </NavLink>
      <NavLink to="/my-servers" className={({ isActive }) => (isActive ? 'active' : '')}>
        My Servers
      </NavLink>
      <NavLink to="/my-appeals" className={({ isActive }) => (isActive ? 'active' : '')}>
        My Appeals
      </NavLink>

      {/* spacer pushes the right-side items to the end;
          on mobile it also forces a line break */}
      <div className="spacer" />

      <button className="button" onClick={toggleTheme} aria-label="Toggle theme">
        🌓
      </button>

      {user ? (
        <>
          <span className="muted" style={{ marginLeft: 8 }}>
            {user.global_name || user.username}
          </span>
          <button className="button" onClick={handleLogout} style={{ marginLeft: 8 }}>
            Log out
          </button>
        </>
      ) : (
        <a className="button" href="/api/auth/login" style={{ marginLeft: 8 }}>
          Log in with Discord
        </a>
      )}
    </nav>
  );
}
